module.exports = __webpack_public_path__ + "static/media/MEDIALOG-logo.b311c223.svg";